import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const KIND_LABEL = {
  farm: "Farm Directory Listing",
  farmstand: "Farmstand Directory Listing",
  market: "Farmers Market Directory Listing",
  seller: "American Farmstand Seller",
};
const KIND = { f: "farm", t: "farmstand", m: "market", s: "seller" };
export const RADII = [10, 25, 50, 100];

let mapCache = { at: 0, promise: null };

export const discoveryApi = {
  map: () => {
    if (!mapCache.promise || Date.now() - mapCache.at > 10 * 60 * 1000) {
      mapCache = { at: Date.now(), promise: axios.get(`${API}/discovery/map`, { ...auth(), timeout: 45000 })
        .then((r) => r.data.points.map((p) => ({ id: p.i, kind: KIND[p.k], name: p.n || "", city: p.c || "", state: p.s || "", lat: p.la, lng: p.lo, verified: !!p.v, accessUnconfirmed: !!p.u, approx: !!p.a })))
        .catch((e) => { mapCache.promise = null; throw e; }) };
    }
    return mapCache.promise;
  },
  places: (q) => axios.get(`${API}/discovery/places`, { ...auth(), params: { q } }).then((r) => r.data.places),
  listing: (id) => axios.get(`${API}/discovery/listings/${encodeURIComponent(id)}`, auth()).then((r) => r.data.listing),
  market: (id) => axios.get(`${API}/marketplace/farmers-markets/${encodeURIComponent(id)}`, auth()).then((r) => r.data.market),
  getPrefs: () => axios.get(`${API}/discovery/prefs`, auth()).then((r) => r.data),
  savePrefs: (body) => axios.post(`${API}/discovery/prefs`, body, auth()).then((r) => r.data),
  request: (body) => axios.post(`${API}/directory/requests`, body).then((r) => r.data),
};

export const distanceMi = (a, b) => {
  const r = 3958.8, toR = (d) => (d * Math.PI) / 180;
  const dLat = toR(b.lat - a.lat), dLng = toR(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toR(a.lat)) * Math.cos(toR(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * r * Math.asin(Math.sqrt(h));
};
